module.exports = __webpack_public_path__ + "static/CM-modules.70aeb0f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CM-modules.png
// module id = 53
// module chunks = 21434532657768 117696030705815 145011745361637